import { GetStaticProps } from 'next'

import NotFoundPage from '@/templates/not-found-template'
import { getContent, getSettingsMarkdowns } from 'lib/content'

import { MetaTags } from '@/components/MetaTags'

export default function NotFound(props: any) {
  return (
    <>
      <MetaTags {...props} />
      <NotFoundPage {...props} />
    </>
  )
}

export const getStaticProps: GetStaticProps<any> = async ({ params }) => {
  const content = await getContent('root', '404')
  const settings = await getSettingsMarkdowns('settings')
  const templateKey = content.templateKey

  const pageProps = {
    pageContent: content,
    settings,
    templateKey,
  }
  return {
    props: {
      ...pageProps,
    },
  }
}
